import React from 'react';
import AudioRecorder from './components/AudioRecorder';
import './App.css';

function App() {
  return (
    <div className="app">
      <AudioRecorder />
    </div>
  );
}

export default App;
